import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "credit-payconfig"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "团队", -1);

const _hoisted_5 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("回款账户设置");

const _hoisted_11 = {
  class: "payconfig-setting-modal"
};

const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "回款至", -1);

const _hoisted_13 = {
  key: 0,
  style: {
    "color": "red",
    "margin-top": "10px"
  }
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("确定");

import { useStore } from 'vuex';
import { ref, onMounted, reactive, computed } from 'vue';
import Axios from '@/request/createAxiosInstalce';
import { getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import { getSalemanSupplier, getEditDistributorList, getDistributorList } from '@/request';
export default {
  name: 'index',

  setup(__props) {
    const store = useStore();
    const userType = computed(() => store.state.user.userType);
    onMounted(() => getOptions());
    const search = ref({
      supplierId: ''
    });
    const supplierList = ref([]);

    function getOptions() {
      // getSalemanSupplier().then(res => {
      //     supplierList.value = res.data
      // })
      Axios.get('/admin/split/rule/getLevelOneSupplierList.json').then(res => {
        supplierList.value = res.data.data;
      });
    }

    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '团队名称',
        field: 'supplierName',
        width: 100
      }, {
        title: '授信业务员',
        field: 'creditSalesManCount'
      }, {
        title: '回款支持线上支付',
        field: 'repaymentOnlineSupport',
        slots: {
          default: 'repaymentOnlineSupport'
        }
      }, {
        title: '回款方',
        field: 'repaymentCncpAccountName',
        slots: {
          default: 'repaymentCncpAccountName'
        }
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        width: 110
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(resolve => {
            let params = _objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, search.value);

            Axios.get('/admin/creditManage/rePaymentTeam/list', {
              params
            }).then(res => {
              if (!res.data.success) return;
              resolve({
                total: res.data.data.total,
                result: res.data.data.list
              });
            });
          })
        }
      }
    });

    function reset() {
      search.value.supplierId = '';
      table.value.commitProxy('reload');
    }

    function switchChange(v, row) {
      let content = v == 1 ? '确认开启吗？' : '确认关闭吗？';
      ElMessageBox.confirm(content, '提示', {
        type: 'warning'
      }).then(() => {
        let url = `/admin/creditManage/rePaymentTeam/onlineRePaymentSupport?supplierId=${row.supplierId}&support=${v}`;
        Axios.post(url).then(res => {
          let {
            success,
            msg
          } = res.data;

          if (success) {
            ElMessage.success('操作成功'); // row.repaymentOnlineSupport = v

            table.value.commitProxy('reload');
          } else {
            ElMessage.error(msg);
          }
        });
      });
    }

    const dialog = reactive({
      show: false,
      data: {
        supplierId: '',
        type: '1',
        account: ''
      },
      branchNames: '',
      branchPayList: []
    });

    function settingHandle(row) {
      let {
        repaymentPartyType,
        repaymentCncpAccount,
        supplierId
      } = row;

      if (repaymentPartyType == null) {
        dialog.data = {
          type: '1',
          account: '',
          supplierId
        };
      } else {
        dialog.data = {
          type: String(repaymentPartyType),
          account: repaymentCncpAccount,
          supplierId
        };
      }

      dialog.show = true;
      dialog.branchNames = '';
      getBranchList(row);
      getBranchPayList();
    }

    function getBranchList(row) {
      getEditDistributorList({
        supplierId: row.supplierId
      }).then(res => {
        let {
          rows = []
        } = res;
        let list = rows.filter(item => {
          return item.paymentFlowStatus != 40 || item.orderPayType == 0;
        });

        if (list.length) {
          dialog.branchNames = list.map(v => v.branchName).join();
        }
      });
    }

    function getBranchPayList() {
      let params = {
        supplierCategory: 2,
        paymentFlowStatus: 40
      };
      getDistributorList(params).then(res => {
        dialog.branchPayList = res.rows || [];
      });
    }

    function submit() {
      let body = {
        supplierId: dialog.data.supplierId,
        repaymentPartyType: dialog.data.type
      };

      if (body.repaymentPartyType == '2') {
        let {
          account
        } = dialog.data;

        if (!account) {
          ElMessage.error('请选择团队回款账户');
          return;
        }

        body.repaymentCncpAccount = dialog.data.account;
      }

      Axios.post('/admin/creditManage/rePaymentTeam/set', body).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
          dialog.show = false;
        } else {
          ElMessage.error(msg);
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_select, {
        modelValue: search.value.supplierId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value.supplierId = $event),
        placeholder: "请选择团队",
        style: {
          "width": "220px"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            value: item.supplierId,
            label: item.supplierName,
            key: item.supplierId
          }, null, 8, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      })]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        repaymentOnlineSupport: _withCtx(({
          row
        }) => [_createVNode(_component_el_switch, {
          "model-value": row.repaymentOnlineSupport,
          "active-value": 1,
          "inactive-value": 0,
          onChange: v => {
            switchChange(v, row);
          }
        }, null, 8, ["model-value", "onChange"])]),
        repaymentCncpAccountName: _withCtx(({
          row
        }) => [row.repaymentPartyType == null ? (_openBlock(), _createElementBlock("div", _hoisted_7, "暂未设置")) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(row.repaymentPartyType == 1 ? '商业公司' : '团队'), 1), row.repaymentCncpAccountName ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(row.repaymentCncpAccountName) + ")", 1)) : _createCommentVNode("", true)]))]),
        operation: _withCtx(({
          row
        }) => [_unref(userType) == 2 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          size: "small",
          onClick: $event => settingHandle(row)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        modelValue: dialog.show,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dialog.show = $event),
        title: "回款账户设置"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => dialog.show = false)
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_15]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_select, {
          modelValue: dialog.data.type,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialog.data.type = $event),
          placeholder: "请选择"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "商业公司",
            value: "1"
          }), _createVNode(_component_el_option, {
            label: "团队",
            value: "2"
          })]),
          _: 1
        }, 8, ["modelValue"]), dialog.branchNames && dialog.data.type == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(dialog.branchNames) + "不支持线上支付，款项仅支持线下回款。", 1)) : _createCommentVNode("", true), dialog.data.type == '2' ? (_openBlock(), _createBlock(_component_el_select, {
          key: 1,
          modelValue: dialog.data.account,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialog.data.account = $event),
          placeholder: "请选择回款账户",
          filterable: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialog.branchPayList, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              label: item.branchName,
              value: item.branchId,
              key: item.branchId
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};